import NietErnstigeBloedingenOnderTar from "../../../../src/client/lta-antistolling/niet-ernstige-bloedingen-onder-tar.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  NietErnstigeBloedingenOnderTar,
  ChartCollapse,
  React
};